<div
  class="pl-spider-chart relative flex w-full flex-col items-center justify-center gap-2"
  [ngClass]="tailwindHeightClass"
>
  <h3 *ngIf="title" class="text-center">{{ title }}</h3>
  <div class="relative flex h-full w-full justify-center">
    <canvas
      baseChart
      [datasets]="radarChartDatasets"
      [options]="radarChartOptions"
      [labels]="radarChartLabels"
      [type]="'radar'"
    >
    </canvas>
  </div>
</div>
